import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    threshold: { type: Number, default: 16 }
  }

  connect() {
    this.frameId = null
    this.handleScroll = this.handleScroll.bind(this)
    this.update = this.update.bind(this)
    this.element.classList.toggle("is-compact", window.scrollY > this.thresholdValue)

    window.addEventListener("scroll", this.handleScroll, { passive: true })
    this.update()
  }

  disconnect() {
    window.removeEventListener("scroll", this.handleScroll)

    if (this.frameId) {
      window.cancelAnimationFrame(this.frameId)
    }
  }

  handleScroll() {
    if (this.frameId) return

    this.frameId = window.requestAnimationFrame(this.update)
  }

  update() {
    const currentScrollY = Math.max(window.scrollY, 0)
    this.element.classList.toggle("is-compact", currentScrollY > this.thresholdValue)

    this.frameId = null
  }
}
